import apiClient from "./client";

/**
 * Eligibility Criteria API Service
 * Handles versioned eligibility criteria CRUD (versions, current, create, approve).
 */
export const eligibilityCriteriaApi = {
  /**
   * Get all eligibility criteria versions for the current tenant.
   */
  getVersions: () => {
    return apiClient.get("/eligibility-criteria/versions");
  },

  /**
   * Get the currently active eligibility criteria version.
   */
  getCurrent: () => {
    return apiClient.get("/eligibility-criteria/current");
  },

  /**
   * Get the eligibility criteria version effective on a specific date.
   * @param {string} date - ISO date string (YYYY-MM-DD)
   */
  getForDate: (date) => {
    return apiClient.get("/eligibility-criteria/for-date", { date });
  },

  /**
   * Ensure an active eligibility criteria exists.
   * If none exists, creates one with today's date and system defaults.
   * Returns the active criteria.
   */
  ensureActive: () => {
    return apiClient.post("/eligibility-criteria/ensure-active");
  },

  /**
   * Create a new eligibility criteria version (pending approval).
   * @param {Object} data - Criteria data including effectiveFrom date
   */
  createVersion: (data) => {
    return apiClient.post("/eligibility-criteria/versions", data);
  },

  /**
   * Approve a pending eligibility criteria version.
   * Automatically closes the previous active version.
   * @param {string} id - Version ID (GUID)
   */
  approveVersion: (id) => {
    return apiClient.post(`/eligibility-criteria/versions/${id}/approve`);
  },
};

export default eligibilityCriteriaApi;
